// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".flex-grow[data-v-38a48a92]{flex:1}.el-menu-demo[data-v-38a48a92]{display:flex;align-items:center}[data-v-38a48a92] .user-menu{margin-left:12px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
